class StorageController {
  //   getFromStorage: any;
  constructor() {
    this.getFromStorage = this.getFromStorage.bind(this);
    this.setToStorage = this.setToStorage.bind(this);
  }

  public getFromStorage(key: string) {
    const data: any = localStorage.getItem(key);
    return JSON.parse(data);
  }
  public setToStorage(key: string, data: any) {
    const payload = JSON.stringify(data);
    localStorage.setItem(key, payload);
  }
}

const storageController = new StorageController();

export default storageController;
